// HonorStudent.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { Print, Description } from "@mui/icons-material";
import testlogo from "./savationChristLogo.png"; // Make sure this path is correct

const HonorStudent = () => {
  return (
    <Box>
      {/* Add marquee CSS */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // stack on mobile
          width: "100%",
          mt: 3,
          gap: 2,
        }}
      >
        {/* Left: Print + Report Card Icons */}
        <Box
          sx={{
            flex: 1,
            minWidth: 250,
            backgroundColor: "#001d30ff",
            color: "gold",
            p: 2,
            borderRadius: 1,
            maxHeight: { xs: "auto", md: 400 },
            overflowY: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 2, md: 3 },
            flexWrap: "wrap",
          }}
        >
<Print sx={{fontSize:{xs:100,sm:150,md:250},color:"rgba(212,160,23,0.7)"}}/>
<Description sx={{fontSize:{xs:100,sm:150,md:250},color:"rgba(184,134,11,0.7)"}}/>
        </Box>

        {/* Right: Image with marquee + description */}
        <Box
          sx={{
            flex: 1,
            minWidth: 250,
            backgroundColor: "#001d30ff",
            borderRadius: 1,
            p: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
            <img
            src={testlogo}
            alt="Honor Image"
            style={{
              width: "100%",
              maxHeight: 200,
              objectFit: "cover",
              borderRadius: 8,
              marginBottom: 16,
            }}
          />
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              mb: 1,
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                display: "inline-block",
                animation: "marquee 15s linear infinite",
                fontWeight: "bold",
                color: "#333",
                fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
              }}
            >
              Congratulations to all our Honoring Students!
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "#555", fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" } }}
          >
            This section highlights students who have achieved outstanding performance in each academic period.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HonorStudent;
